import { matchPath } from 'react-router-dom';

export type TopbarKind =
  | 'default'
  | 'empty'
  | 'invoice_detail'
  | 'inventory_detail'
  | 'invoices_list'
  | 'gopos_orders'
  | 'product_categories'
  | 'products'
  | 'ingredients'
  | 'write_offs'
  | 'transfers'
  | 'receipts'
  | 'supplier_returns'
  | 'productions'
  | 'recipes'
  | 'b2b_sales'
  | 'inventories'
  | 'balances'
  | 'stock_operations'
  | 'stock_titled'
  | 'seller_workspace'
  | 'expiry_risk'
  | 'b2b_customers'
  | 'bank'
  | 'payments'
  | 'money'
  | 'analytics_sales'
  | 'analytics';

const EXACT_TOPBAR_ROUTES: ReadonlyArray<readonly [path: string, kind: TopbarKind]> = [
  ['/webadmin/app/invoices', 'invoices_list'],
  ['/webadmin/app/gopos/orders', 'gopos_orders'],
  ['/webadmin/app/stock/products/categories', 'product_categories'],
  ['/webadmin/app/stock/products', 'products'],
  ['/webadmin/app/stock/ingredients', 'ingredients'],
  ['/webadmin/app/stock/write-offs', 'write_offs'],
  ['/webadmin/app/stock/transfers', 'transfers'],
  ['/webadmin/app/stock/receipts', 'receipts'],
  ['/webadmin/app/stock/supplier-returns', 'supplier_returns'],
  ['/webadmin/app/stock/productions', 'productions'],
  ['/webadmin/app/stock/recipes', 'recipes'],
  ['/webadmin/app/stock/b2b-sales', 'b2b_sales'],
  ['/webadmin/app/stock/inventories', 'inventories'],
  ['/webadmin/app/stock/balances', 'balances'],
  ['/webadmin/app/stock/operations', 'stock_operations'],
  ['/webadmin/app/stock/platform-sales', 'stock_titled'],
  ['/webadmin/app/stock/sales-invoices', 'stock_titled'],
  ['/webadmin/app/stock/hot-reports', 'stock_titled'],
  ['/webadmin/app/settings/b2b-customers', 'b2b_customers'],
  ['/webadmin/app/bank', 'bank'],
  ['/webadmin/app/payments', 'payments'],
  ['/webadmin/app/bank/receipts', 'money'],
  ['/webadmin/app/money/inbox', 'money'],
  ['/webadmin/app/money/cards', 'money'],
  ['/webadmin/app/reconciliation/cases', 'money'],
  ['/webadmin/app/analytics/sales', 'analytics_sales'],
];

export function resolveTopbarKind(pathname: string): TopbarKind {
  if (
    pathname === '/webadmin/app/stock/seller-workspace' ||
    pathname === '/webadmin/app/stock/seller-workspace/requests' ||
    pathname.startsWith('/webadmin/app/stock/seller-workspace/receiving') ||
    pathname === '/webadmin/app/stock/seller-workspace/balances' ||
    pathname === '/webadmin/app/stock/seller-workspace/sale-changes' ||
    pathname === '/webadmin/app/stock/seller-workspace/write-offs' ||
    pathname === '/webadmin/app/stock/seller-workspace/productions' ||
    pathname === '/webadmin/app/stock/seller-workspace/scanner' ||
    pathname === '/webadmin/app/stock/seller-workspace/expiry' ||
    pathname === '/webadmin/app/stock/seller-workspace/counts'
  ) {
    return 'seller_workspace';
  }

  // The owner's page names itself in the topbar like the other admin pages.
  if (pathname.replace(/\/$/, '') === '/webadmin/app/stock/seller-workspace/expiry-risk') {
    return 'expiry_risk';
  }

  if (
    pathname === '/webadmin/app/stock/seller-workspace' ||
    pathname.startsWith('/webadmin/app/stock/seller-workspace/')
  ) {
    return 'empty';
  }

  const inventoryDetailMatch =
    matchPath('/webadmin/app/stock/inventories/:id/edit', pathname) ??
    matchPath('/webadmin/app/stock/inventories/:id', pathname);
  const inventoryId = inventoryDetailMatch?.params.id ?? null;
  if (inventoryId && inventoryId !== 'new') {
    return 'inventory_detail';
  }

  if (matchPath('/webadmin/app/invoices/:id', pathname)) {
    return 'invoice_detail';
  }

  for (const [path, kind] of EXACT_TOPBAR_ROUTES) {
    if (pathname === path) {
      return kind;
    }
  }

  if (pathname === '/webadmin/app/analytics' || pathname.startsWith('/webadmin/app/analytics/')) {
    return 'analytics';
  }

  return 'default';
}
